<template>
  <b-form-group
    label="Kiracı Telefon"
    label-for="phone"
  >
    <b-form-input
      id="phone"
      v-model="dataItem.tenants.phone"
      readonly
      disabled
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'TenantCode',
  components: {
    BFormInput,
    BFormGroup,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
}
</script>
